// Automatic campaign types - must match the API (AutomationCampaign::TYPE_* / AVAILABLE_TYPES).
// Only the available ones can be picked when creating a campaign.
export const AUTOMATION_TYPE_BIRTHDAY = 1
export const AUTOMATION_TYPE_CART = 3

export const AUTOMATION_TYPES = [
  { value: 1, label: 'marketingAutomation.typeBirthday', icon: 'fa fa-birthday-cake', available: true },
  { value: 2, label: 'marketingAutomation.typeGeofencing', icon: 'fa fa-map-marker', available: false },
  { value: 3, label: 'marketingAutomation.typeAbandonedCart', icon: 'fa fa-shopping-cart', available: true },
  { value: 4, label: 'marketingAutomation.typeProductViews', icon: 'fa fa-eye', available: false }
]



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/AutomationCampaigns/automationTypes.js